import { render, staticRenderFns } from "./sfc-wisepops.vue?vue&type=template&id=11592ea8&"
import script from "./sfc-wisepops.vue?vue&type=script&lang=js&"
export * from "./sfc-wisepops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports